import 'whatwg-fetch';
import appendAuthHeader from './append-auth-header';

export default async (resource, init = {}) =>
{
  if (resource instanceof window.Request) { return window.fetch(resource); }

  const { headers, cache = 'reload', credentials = 'include' } = init;
  const initToSend = {
    ...init,
    cache,
    credentials,
    headers: appendAuthHeader(headers)
  };

  return window.fetch(resource, initToSend);
};
